var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCapacitebleu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.199,
    height: 18.262,
    viewBox: "0 0 21.199 18.262",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "capacite-vert",
    transform: "translate(-3306.5 -2491.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_213",
    "data-name": "Groupe 213",
    transform: "translate(3156.614 2290.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_63",
    "data-name": "Groupe 63",
    transform: "translate(149.886 201.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_44",
    "data-name": "Trac\\xE9 44",
    d: "M208.191,226.5a.783.783,0,0,1-.834.5c-.916-.015-1.833-.008-2.749,0-.144,0-.189-.037-.184-.184.011-.337.009-.675,0-1.013,0-.136.039-.174.174-.173.682.006,1.364,0,2.046.006.14,0,.184-.031.187-.18a4.246,4.246,0,0,0-.387-2.168,4.981,4.981,0,0,0-.323-.527c-.063-.089-.057-.134.027-.2.284-.218.567-.439.842-.668.1-.084.151-.07.225.032a4.959,4.959,0,0,1,.935,2.307c.007.054,0,.112.042.155Z",
    transform: "translate(-186.992 -215.303)",
    fill: "#5270a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_45",
    "data-name": "Trac\\xE9 45",
    d: "M164.605,214.152c0,.531,0,1.062,0,1.594,0,.14-.035.194-.184.19-.331-.011-.663-.013-.993,0-.168.007-.207-.05-.206-.21.006-1.048,0-2.1.007-3.146,0-.153-.044-.213-.194-.243a4.67,4.67,0,0,1-3.8-4.077c-.029-.227-.165-.114-.251-.1a3.4,3.4,0,1,1,2.435-4.71c.083.19.145.179.3.1a4.618,4.618,0,0,1,4.382.006c.153.077.2.073.268-.095a3.4,3.4,0,1,1,3.487,4.7,3.283,3.283,0,0,1-1.088-.065c-.156-.035-.172.019-.186.142a4.687,4.687,0,0,1-3.4,4.009l-.1.03c-.158.045-.373.009-.464.127s-.028.333-.03.5C164.6,213.324,164.605,213.738,164.605,214.152Zm-.7-9.772a3.337,3.337,0,1,0,3.359,3.343A3.352,3.352,0,0,0,163.907,204.38Zm5.608-1.62a2.017,2.017,0,0,0-2.015,1.719.315.315,0,0,0,.075.28,4.43,4.43,0,0,1,.859,1.63.335.335,0,0,0,.2.234,2.03,2.03,0,1,0,.877-3.862Zm-11.239.046a1.6,1.6,0,0,0-.248.014,1.965,1.965,0,0,0-1.645,1.44,1.9,1.9,0,0,0,.63,2.106,1.955,1.955,0,0,0,2.163.306.317.317,0,0,0,.2-.232,4.5,4.5,0,0,1,.881-1.689.278.278,0,0,0,.065-.243A2.031,2.031,0,0,0,158.277,202.805Z",
    transform: "translate(-153.314 -201.384)",
    fill: "#5270a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_46",
    "data-name": "Trac\\xE9 46",
    d: "M168.076,241.759H161.93c-.628,0-.879-.248-.873-.878.008-.827-.032-1.655.031-2.482a6.873,6.873,0,0,1,1.669-4.03c.121-.142.258-.269.379-.41.082-.1.138-.1.227,0,.235.261.476.518.726.765.1.1.081.15-.009.24a5.534,5.534,0,0,0-1.522,2.789,10.273,10.273,0,0,0-.131,2.183c0,.448,0,.448.439.448q5.308,0,10.616,0c.2,0,.274-.038.267-.258a13.618,13.618,0,0,0-.114-2.268,4.431,4.431,0,0,0-.136-.56c-.041-.121,0-.152.1-.185.334-.106.668-.215,1-.335.131-.048.172-.013.211.116a7.1,7.1,0,0,1,.3,1.932c.014.71.008,1.421,0,2.131a.71.71,0,0,1-.789.8Q171.2,241.763,168.076,241.759Z",
    transform: "translate(-157.483 -223.498)",
    fill: "#5270a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_47",
    "data-name": "Trac\\xE9 47",
    d: "M151.986,227.024c-.462,0-.924,0-1.386,0a.651.651,0,0,1-.705-.709,19.1,19.1,0,0,1,.039-2.025,4.972,4.972,0,0,1,.985-2.4c.072-.1.123-.1.213-.024q.411.346.834.679c.081.064.1.11.029.2a4,4,0,0,0-.741,2.79c.007.149.094.121.179.121.662,0,1.324.005,1.986,0,.15,0,.206.031.2.192-.013.338-.009.676,0,1.014,0,.127-.033.166-.162.164-.49-.007-.979,0-1.469,0Z",
    transform: "translate(-149.886 -215.286)",
    fill: "#5270a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_48",
    "data-name": "Trac\\xE9 48",
    d: "M197.3,235.079c-.008.059-.054.071-.087.093-.31.2-.623.406-.931.614-.083.056-.125.041-.179-.039a4.946,4.946,0,0,0-.7-.838c-.069-.065-.054-.108,0-.168.259-.268.514-.538.77-.808.049-.051.086-.1.164-.027a7.107,7.107,0,0,1,.925,1.109C197.276,235.038,197.287,235.062,197.3,235.079Z",
    transform: "translate(-180.821 -223.484)",
    fill: "#91c450"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCapacitebleu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/capacitebleu.1f18546c.svg";
export { ForwardRef as ReactComponent };